import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useCopy } from '../clipboard/clipboard'
import { useFormDisable } from './form'
import { FormatLabel } from './format-label'
import { useFormDefaultNull, useFormRequired, useFormShouldDirty, useGetWatchValue } from './hooks/input-hooks'

export const FormURL = ({ label, placeholder, subtext, name, required, readOnly, defaultValue, shouldDirty, autoFocus, hidden }) => {
  const { register } = useFormContext()

  let formDisabled = useFormDisable()

  let watchValue = useGetWatchValue(name)

  useFormDefaultNull(name)
  useFormRequired(name, required)
  useFormShouldDirty(name, defaultValue, shouldDirty)

  // Copied inside the click (shared/clipboard), so Safari allows it;
  // "Copied" only after a real copy, otherwise the field is selected.
  const copy = useCopy()
  const handleCopy = e => copy.copy(watchValue, e.currentTarget.parentElement.querySelector('input'))

  const handleOpen = () => window.open(watchValue)

  return (
    <React.Fragment>
      <FormatLabel name={name} label={label} subtext={subtext} hasValue={!!watchValue} required={required} hidden={hidden}>
        <div className="input-group">
          <input
            className="form-control"
            placeholder={placeholder || label}
            autoFocus={autoFocus}
            type="text"
            {...register(name, { required })}
            disabled={formDisabled}
            readOnly={readOnly}
            hidden={hidden}
          />
          <div className="btn-group-append" onClick={handleCopy}>
            <span className={`${'input-group-text'} ${copy.copied && 'bg-info text-white'}`} style={{ cursor: 'pointer' }} role="status">
              {copy.copied ? 'Copied' : copy.manual ? copy.hint : 'Copy'}
            </span>
          </div>
          <div className="btn-group-append" onClick={handleOpen}>
            <span className="input-group-text" style={{ cursor: 'pointer' }}>
              Open
            </span>
          </div>
        </div>
      </FormatLabel>
    </React.Fragment>
  )
}
